import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.addEventListener('DOMContentLoaded', () => {
  illustrationAnimation();
  linesAnimation();
  timelineAnimation();

  if (!window.is_mobile) {
    bottomVideosAnimation();
  }
});

const illustrationAnimation = () => {
  const all_illus = document.querySelectorAll('.history--images .media-image:not(.no--resize) img');
  [...all_illus].map(img => {

    gsap.set(img, {
      width: `${img.getAttribute('width') * 100 / (window.is_mobile ? 1024 : 1920)}vw`,
      height: window.is_mobile ? 'auto' : `${img.getAttribute('height') * 100 / 1920}vw`,
      onComplete: () => {
        gsap.to(img.closest('figure'), .3, {
          opacity: 1,
        });
      },
    });

  });

  const illustrations_header = document.querySelectorAll('.history--images.history-header--illustrations > div');

  [...illustrations_header].map((image, index) => {
    gsap.to(image, .8, {
      y: 0, opacity: 1, delay: index * .2,
      onComplete: () => {
        const tapes = image.querySelectorAll('.history-tape--wrapper .media-image img');

        [...tapes].map((tape, index) => {
          gsap.to(tape, .3, {
            scale: 1,
            delay: index * .2,
          });
        });
      },
    });
  });

  const illustrations_scroll = document.querySelectorAll('.history--images:not(.history-header--illustrations) .illu--stuck');

  [...illustrations_scroll].map(image => {
    const img = image.querySelector('img');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: image,
        scrub: 1,
        markers: false,
        ease: 'power.5',
      },
    });

    tl.from(img, {
      opacity: 0,
    }).to(img, {
      opacity: 1,
    });
  });

  window.addEventListener('scroll', () => {
    [...illustrations_scroll].map((image, index) => {
      const rect = image.getBoundingClientRect();

      gsap.set(image, {
        y: (window.innerHeight - rect.top) * (index % 2 === 0 ? -.2 : .2),
      });
    });
  });
};

const linesAnimation = () => {
  const lines = document.querySelectorAll('.history--line, .architecture--line');

  [...lines].map(line => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: line.closest('div'),
        scrub: 1,
        markers: false,
        start: '-10% center',
      },
    });

    tl.from(line, {
      scaleY: 0,
    }).to(line, {
      scaleY: 1,
    });
  });
};

const timelineAnimation = () => {
  const timelineTrain = document.querySelector('.timeline--train');
  const timelineRails = document.querySelector('.timeline--rails');
  const dates = document.querySelectorAll('.history-dates--timeline .time--wrapper');

  window.addEventListener('scroll', () => {
    const offset_screen = window.innerHeight / 2;
    const railsRect = timelineRails.getBoundingClientRect();

    if ((offset_screen - railsRect.top <= 0) && (railsRect.bottom <= 0)) {
      return false;
    }

    gsap.to(timelineTrain, .3, {
      height: offset_screen - railsRect.top + 'px',
    });

    [...dates].map((date, index) => {
      const dateRect = date.getBoundingClientRect();
      if (offset_screen - dateRect.top >= 0) {
        if (window.scrollDirection === 'down') {
          date.classList.add('active');
        }
      }
      else if ((offset_screen - dateRect.top <= 0)) {
        if (window.scrollDirection === 'up') {
          date.classList.remove('active');
        }
      }
    });
  });

  if (window.is_mobile) return false;

  const listingArchi = document.querySelectorAll('.history-architecture--figures ul li');
  const listingDates = document.querySelectorAll('.history-dates--timeline ul li');
  const tl_listing = (item, index) => {
    const listingTl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        scrub: 1,
        markers: false,
        start: '-100px center',
        end: '150px center',
      },
    });

    listingTl.from(item.querySelectorAll('time, p, figure'), {
      x: (index % 2 === 0) ? (item.closest('.history-architecture--figures') ? -50 : 50) : (item.closest('.history-architecture--figures') ? 50 : -50),
      opacity: 0,
    }).to(item.querySelectorAll('time, p, figure'), {
      x: 0,
      opacity: 1,
    });
  };

  [...listingArchi].map((item, index) => tl_listing(item, index));
  [...listingDates].map((item, index) => tl_listing(item, index));

};

const bottomVideosAnimation = () => {
  const videos = document.querySelectorAll('.history-videos--wrapper .media-video');

  [...videos].map((video, index) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.history-videos--wrapper',
        scrub: 1,
        markers: false,
        start: 'top center',
        end: '120% bottom',
      },
    });

    tl.from(video, {
      opacity: 0,
      x: index === 0 ? -100 : 100,
    }).to(video, {
      opacity: 1,
      x: 0,
    });
  });
};
